import { OrganizationDetailForm } from '@features/admin/organizations/OrganizationDetailForm';
import { useOrganizationById } from '@hooks/useOrganizationById';
import { Box, Typography } from '@mui/material';
import { usePageTitle } from '@shared/hooks/usePageTitle';
import React from 'react';
import { useParams } from 'react-router-dom';
import NotFoundPage from './NotFoundPage';

const OrganizationPage: React.FC = () => {
  usePageTitle('Manage Organization');
  const { id } = useParams<{ id: string }>();
  const organizationId = Number(id);
  const isValidId = Number.isInteger(organizationId);
  // A non-numeric path segment must not reach the API as /organizations/NaN, and the
  // early return below cannot prevent that because the hook has already run
  const { organization, loading, error } = useOrganizationById(isValidId ? organizationId : undefined);

  if (!isValidId) return <NotFoundPage />;
  // Not found and not permitted read the same over the API, so say so rather than
  // rendering an empty page that is indistinguishable from still loading
  if (error) return <NotFoundPage />;
  if (loading) {
    return (
      <Box margin={2} paddingTop={2} marginTop={0}>
        <Typography fontSize={12}>Loading organization...</Typography>
      </Box>
    );
  }
  if (!organization) return <NotFoundPage />;

  return (
    <Box margin={2} paddingTop={2} marginTop={0}>
      <OrganizationDetailForm organization={organization} />
    </Box>
  );
};

export default OrganizationPage;
